import {useEffect, useState} from 'react';
import {MEDIA_ORIENTATIONS, MediaOrientation} from '@/types/mediaOrientation';

export type MediaOrientationResult = {
  orientation: MediaOrientation;
  aspectRatio: number;
};

const DEFAULT_ASPECT_RATIO = 16 / 9;

function useMediaOrientation(
  url: string | null | undefined
): MediaOrientationResult | null {
  const [result, setResult] = useState<MediaOrientationResult | null>(null);

  useEffect(() => {
    if (!url) {
      return;
    }
    setResult(null);
    const img = new Image();
    img.onload = () => {
      const aspectRatio = img.width / img.height;
      setResult({
        orientation:
          img.height > img.width
            ? MEDIA_ORIENTATIONS.PORTRAIT
            : MEDIA_ORIENTATIONS.LANDSCAPE,
        aspectRatio,
      });
    };
    img.onerror = () => {
      setResult({
        orientation: MEDIA_ORIENTATIONS.LANDSCAPE,
        aspectRatio: DEFAULT_ASPECT_RATIO,
      });
    };
    img.src = url;
  }, [url]);

  return result;
}

export default useMediaOrientation;
